import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Evita que el overlay de desarrollo muestre falsos positivos de ResizeObserver.
const _resizeObserverMsgRegex =
  /ResizeObserver loop (limit exceeded|completed with undelivered notifications)/i;

if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    const message =
      event?.message ||
      event?.error?.message ||
      '';
    if (_resizeObserverMsgRegex.test(message)) {
      event.stopImmediatePropagation();
    }
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reasonMessage =
      event?.reason?.message ||
      `${event?.reason || ''}`;
    if (_resizeObserverMsgRegex.test(reasonMessage)) {
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
